import styled from 'styled-components';

import {ms} from '../../../../styles';
import {TextArea} from '../../../../uikit/TextArea';
import {View} from '../../../../uikit/View';

export const ReasonContainer = styled(View)`
  flex-direction: column;
  row-gap: ${ms(20)};
  padding-inline: ${ms(24)};
  padding-block-end: ${ms(20)};
`;

export const OptionsList = styled(View)`
  flex-direction: column;
  row-gap: ${ms(20)};
`;

export const OptionContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  column-gap: ${ms(8)};
`;

export const CustomReasonContainer = styled(View)`
  flex-direction: column;
  row-gap: ${ms(8)};
`;

export const CustomReasonInput = styled(TextArea)`
  height: ${ms(88)};
  resize: vertical;
`;
